/**
 * Selfie prompts for ID verification. We randomize on sheet open so screenshots
 * of a stale prompt can't be reused. The exact prompt is stored on the
 * submission so reviewers can confirm the user followed it.
 */
export const ID_SELFIE_PROMPTS: string[] = [
  'Hold up 3 fingers with your right hand next to your face',
  'Hold up 2 fingers with your left hand next to your face',
  'Hold up 4 fingers with your right hand next to your face',
  'Make a thumbs-up with your right hand next to your face',
  'Make a peace sign with your left hand next to your face',
  'Hold up 1 finger with your right hand next to your face',
];

export function pickSelfiePrompt(): string {
  return ID_SELFIE_PROMPTS[Math.floor(Math.random() * ID_SELFIE_PROMPTS.length)];
}

export type IdVerificationStatus = 'none' | 'pending' | 'approved' | 'rejected';
